import getChartsTracksURL, {
  IChartsTracksURLArgs,
} from 'url-constructors/getChartsTracksUrl';
import getByUrl from './helper/getByUrl';

interface IChartTerritoryData {
  previousPosition: number;
  peakPosition: number;
  chartStreams: number;
  daysOnChart: number;
  weeksOnChart: number;
  currentPosition: number;
}

export interface IChartTrackData extends IChartTerritoryData {
  artistId: number;
  artistName: string;
  isNewEntry: boolean;
  position: number;
  productId: string;
  productTitle: string;
  productType: string;
  dealTypeList: string[];
  streamCount: number;
  customRegion?: string | string[];
  region?: string;
}

const chartsTableDataInterceptor = async (
  input: RequestInfo /* eslint-disable-line */,
  init: RequestInit | undefined /* eslint-disable-line */,
  interceptionData?: any
): Promise<Response> => {
  const {
    chartId,
    countryId,
    chartPage,
    limit,
    chartLimit = 999,
    chartOffset,
    offset,
    chartFrequency,
    date,
    sortBy = 'chartId',
    sortOrder = 'desc',
    customerFilter,
    filters,
  } = interceptionData;

  const chartsTracksOptions = {
    chartType: chartPage,
    sortBy,
    sortOrder,
    limit: chartLimit,
    trackLimit: limit,
    trackOffset: offset,
    offset: chartOffset,
    chartIds: chartId,
    countryIds: countryId,
    chartFrequency,
    date,
    customerFilter,
    region: filters?.region,
    customRegion: filters?.customRegion,
  };

  const url = getChartsTracksURL(chartsTracksOptions as IChartsTracksURLArgs);

  try {
    const { charts, availableDates, totalChartsCount } = await getByUrl<any>(
      url
    );

    const isTopCharts = interceptionData.chartLimit;

    if (!isTopCharts) {
      const selectedChart = charts[0];

      const {
        chartName,
        dateKey,
        wmgTracksPercentage,
        totalTracksCount,
      } = selectedChart;

      return new Response(
        JSON.stringify({
          chartName,
          chartDate: dateKey,
          wmgTracksPercentage,
          trackData: {
            tracks: selectedChart.data,
          },
          url,
          totalTracksCount,
          availableDates,
        })
      );
    } else {
      return new Response(
        JSON.stringify({
          chartsTable: charts,
          totalChartsCount,
          url,
        })
      );
    }
  } catch (error) {
    return new Response(JSON.stringify({ reason: error.message }));
  }
};

export default chartsTableDataInterceptor;
